import { ListGroup } from 'react-bootstrap'
import '../../scss/verticalTimeline.scss'

const timelineData = [
  {
    id: '1',
    title: 'University of Colorado Boulder',
    date: 'August 2022 - May 2024',
    shortDescription: 'Master of Science in Computer Science',
    shortDescription:'GPA - 3.8/4.0',
    description:
      "Recent graduate student with a Master's degree in Computer Science from the University of Colorado Boulder. With a strong technical acumen and problem-solving abilities, I am passionate about technology and its potential to drive positive change in society.",
    tags: [
      'Neural Networks and Deep Learning',
      'Natural Language Processing',
      'Design and Analysis of Algorithms',
      'Big Data Architecture',
      'Big Data Analytics',
      'Data Center Scale Computing',
      'Leading Oneself',
    ],
  },
  {
    id: '2',
    title: 'TEAM Services Group',
    date: 'June 2023 - Decemeber 2023',
    shortDescription: 'Data Engineer Intern',
    bulletedList: [
      'Analyzed, streamlined, and transformed data from diverse sources(financial reporting, operational reporting) by building ETL processes using Python and robust data models using Data Build Tool (DBT) with SQL programming, Hevo Data, and Snowflake.',
      'Strategically developed innovative software designs and collaborated with multi-functional teams to implement data ingestion pipelines and ETL workflows using cloud technologies such as Azure Blob Storage, Azure Data Factory, and Serverless function apps, achieving a significant boost in data processing speed.',
      'Collaborated with the Finance team to create visually appealing dashboards using tools like Sigma BI and Tableau, eventually increasing efficiency by 30% and improving the decision-making process.',
      'Analyzed relational databases and implemented data warehousing solutions with Snowflake, utilizing Fivetran as a connector to achieve a 25% reduction in data processing time, enhancing overall workflow efficiency.'
    ],
    tags: ['ELT', 'SQL Programming', 'Python', 'Snowflake', 'Azure Function App', 'Azure Data Factory', 'Azure Blob Storage', 'Data Build Tool(DBT)', 'Hevo Data', 'Sigma Computing(data visualization tool)', 'Oracle NetSuite ERP', 'Data Modeling', 'Data Analytics'],
  },
  {
    id: '3',
    title: 'MUST Research Academy',
    date: 'March 2022 - November 2023',
    shortDescription: 'Certified Applied Data Scientist Program - Learn and Invent module',
    bulletedList: [
      'Completed the Learn module, which covered advanced topics in Artificial Intelligence and Machine Learning, including Deep Neural Networks, Convolutional Neural Networks, Recurrent Neural Networks, Transformers, and Deep Reinforcement Learning, with a focus on real-world applications and industry use cases.',
      'Participated in the Invent module, which involved collaborative innovation and patent development, resulting in the successful filing of a patent titled "METHOD AND SYSTEM FOR PRODUCT RECOMMENDATION BASED ON USER INTERACTION" with Indian Patent Office, showcasing expertise in advanced AI applications and system design for enhanced online shopping experiences.',
      'Patent Description: Developed a method and system for enhancing online shopping experiences by creating dynamic user groups and integrating a personalized conversational SalesBot.',
    ],
    tags: ['Research', 'Deep Learning', 'Machine Learning', 'Natural Language Processing', 'Apllied Artificial Intelligence', 'Sentiment Analysis', 'Reinforcement Learning', 'Recommendation systems'],
  },
  {
    id: '4',
    title: 'UBS',
    date: 'August 2020 - October 2021',
    shortDescription: 'Software Engineer',
    bulletedList: [
      "Transformed Java Springboot application performance by designing and implementing cloud infrastructure with Logstash and Apache Kafka, achieving a 15% reduction in real-time trade event processing time and increasing system efficiency by 30%.",
      "Deployed and scaled microservices for application instances in APAC, EMEA & AUS regions using Azure Kubernetes Service and Pivotal Kubernetes Service, improving applications’ scalability, and increasing system availability by 20%.",
      "Initiated development of reusable Java and Python libraries to manage secure credentials for 150+ software applications utilizing HashiCorp Enterprise Vault, increasing system security compliance by 30%.",
      "Adapted to the business requirement and improved processing by 25% through containerizing and re-engineering a Java Spring MVC reporting application using EhCache data storage solution backed with Azure Postgres database(utilized Hibernate)."
    ],
    tags: ['Microservice Architecture', 'Docker', 'Kubernetes', 'Automation', 'Apache Kafka', 'Elasticsearch', 'Logstash', 'Python', 'Java', 'SpringBoot', 'Spring MVC', 'Hibernate', 'JUnit', 'Git', 'Gitlab', 'Microsoft Azure', 'PostgreSQL', 'SQL', 'EhCache', 'CI/CD', 'Moogsoft(AIOps)', 'AppDynamics'],
  },
  {
    id: '5',
    title: 'UBS',
    date: 'May 2019 - July 2019',
    shortDescription: 'Software Engineer Intern',
    bulletedList: [
      'Enhanced software development lifecycle for applications by adopting DevOps practices like CI/CD with Kubernetes, Docker, and Puppet; increased deployment frequency by 15% and reduced lead time to market by 40%.',
      'Streamlined various migration tasks by building automation scripts with Bash scripting and Python, reducing manual effort by 60% across all applications.',
    ],
    tags: ['DevOps', 'CI/CD', 'Automation', 'Git', 'Docker', 'Puppet', 'Shell scripting', 'Powershell', 'Linux', 'Bash', 'Python'],
  },
  {
    id: '6',
    title: 'Our Smart Solutions LLP',
    date: 'June 2017 - July 2018',
    shortDescription: 'Web Developer Intern',
    description: "Developed a website using BootStrap for the company’s product which enables efficient management of housing society related workflow.",
    tags: [
      'ReactJS',
      'Bootstrap',
      'MySQL',
      'REST APIs',
      'HTML',
      'CSS',
    ],
  },
  {
    id: '7',
    title: "MKSSS's Cummins College of Engineering for Women (Savitribai Phule Pune University)",
    date: 'August 2016 - October 2020',
    shortDescription: 'Bachelor of Technology in Information Technology',
    shortDescription:'GPA - 8.86/10.00',
    description:
      "Completed my Bachelors's degree in Information Technology from Cummins College of Engineering, Pune, India.",
    tags: [
      'Algorithm Design and Analysis',
      'Operating Systems',
      'Computer Organization and Architecture',
      'Discrete Structures',
      'Theory of Computations',
      'Network Fundamentals',
      'Object Oriented Paradigms',
      'Introduction To Digital Marketing',
      'Database Management Systems',
      'Web Engineering Technology',
      'Software Engineering',
      'Machine Learning',
      'Artificial Intelligence',
      'Cloud Computing',
      'Green Computing',
      'Soft Computing',
      'Software Architecture And Design Patterns',
      'Information And Cyber Security',
      'Information Retrieval'
    ],
  },
  
]

const TimelineCard = ({
  title,
  date,
  shortDescription,
  description,
  bulletedList,
  tags,
}) => {
  return (
    <div className="relative pl-8 sm:pl-32 py-6 group">
      <div className="font-caveat font-medium text-xl text-primary mb-1 sm:mb-0">
        {title}
      </div>
      
      <div className="flex flex-col sm:flex-row items-start mb-1 group-last:before:hidden 
        before:absolute before:left-2 sm:before:left-0 before:h-full before:px-px
      before:bg-accent sm:before:ml-[6.5rem] before:self-start before:-translate-x-1/2 before:translate-y-3 
      after:absolute after:left-2 sm:after:left-0 after:w-2 after:h-2 after:bg-primary after:border-4 after:box-content 
      after:border-accent after:rounded-full sm:after:ml-[6.5rem] after:-translate-x-1/2 after:translate-y-1.5"
      >
      <time className="sm:absolute left-0 translate-y-0.5 inline-flex items-center justify-center text-xs font-semibold uppercase w-36 sm:w-20 h-6 mb-3 sm:mb-0 text-primary bg-primary-background rounded-full">
        {date}
      </time>
      <div className="text-md font-bold text-muted-foreground dark:text-muted">
        {shortDescription}
      </div>
    </div>
      
    {description && (
      <div className="text-muted-foreground mb-2">{description}</div>
    )}
    {bulletedList && (
      <ul className="list-disc list-inside text-muted-foreground mb-2">
        {bulletedList.map((item) => (
        <li>{item}</li>
        ))}
      </ul>
    )}
      
    <ul className="flex gap-3 mb-6 md:mb-10 flex-wrap items-center">
      {tags.map((tag) => (
        <li className="text-sm flex items-center border bg-transparent rounded-full px-4 py-2">
        {tag}
        </li>
      ))}
    </ul>
  </div>
  )
}
      
const VerticalTimeline = () => {
  return (
    <div className="container my-16">
      <h1 className='display-4 mb-5 text-center' id="professionaljourney">Professional Journey</h1>
      {timelineData.map((data) => (
        <TimelineCard key={data.id} {...data} />
      ))}
    </div>
  )
}
    
export default VerticalTimeline